module.exports = __webpack_public_path__ + "static/img/XczjNew1@2x.957a6df2.png";